import { Logout } from '@/utils/common';
import CryptoJS from 'crypto-js';

const secretKey = 'AB12JHU';

/**
 * Encrypts the given data using AES encryption.
 *
 * @param {Object} data - The data to be encrypted.
 * @returns {string} The encrypted data as a ciphertext string.
 */
export const encryptData = (data) => {
  if (!data) return null;
  return CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
};

/**
 * Decrypts the given ciphertext back to its original data format.
 *
 * @param {string} cipherText - The encrypted data as a ciphertext string.
 * @returns {Object} The decrypted data.
 * @throws Will throw an error if the decryption fails or the data cannot be parsed.
 */
export const decryptData = (cipherText) => {
  if (!cipherText) return null;
  try {
    const bytes = CryptoJS?.AES?.decrypt(cipherText, secretKey);

    return JSON.parse(bytes?.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.log(error);
    Logout();
    window.location.replace('/login/');
  }
};
